<template>
  <div class="card">
    <div class="card-body">
      <div v-show="isHR" class="pt-20 pb-20 pr-20 pl-20">
        <h5 class="card-title text-center font-weight-bold">Leave Records & Schedule</h5>
        <div v-if="loading" class="row card-body">
          <div class="loader"></div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div style="background: #f2f2f2" class="card">
              <div class="card-body d-flex align-items-center">
                <div class="col-12 col-md-12">
                  <div class="numbers d-flex flex-column">
                    <p class="card-category text-info fw-600 fs-20">
                      Pending Leaves
                    </p>
                    <p class="card-title">{{ getPendingLeaves }}</p><p>
                  </p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 mb-15">
            <label for="">Status</label>
            <select v-model="status" class="form-control" name="" id="">
              <option value="" disabled>Select</option>
              <option value="approved">Approved</option>
              <option value="pending">Pending</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
          <div class="col-md-2 mb-15">
            <label for="">Date</label>
            <date-range-picker
                class="w-100"
                ref="picker"
                :showDropdowns="true"
                v-model="dateRange"
            >
              <template v-slot:input="picker" style="min-width: 350px; padding: 9px 10px;">
                {{ (picker.startDate) ? formattedDateWithOutTime(picker.startDate) + ' - ' + formattedDateWithOutTime(picker.endDate) : 'Select Date Range' }}
              </template>
            </date-range-picker>
          </div>
          <div class="col-md-2 mb-15 mt-15">
            <button @click="resetFilters" class="btn btn-sm btn-danger btn-outline-danger" style="height: 33px">Reset</button>
          </div>
          <div class="col-md-6 d-flex justify-content-end" style="gap: 8px;">
            <button style="height: 30px" @click="exportCSV" class="btn btn-success btn-sm btn-outline-success">
              <i class="fa fa-download mr-1"></i> Export CSV
            </button>
<!--            <button style="height: 30px" @click="openLeaveModal" class="btn btn-primary btn-sm btn-outline-primary">Apply Staff Leave</button>-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <table id="allLeavesTable" class="table table-bordered">
              <thead class="table-light">
              <tr>
                <th class="text-center">Employee Name</th>
                <th class="text-center">Department</th>
                <th class="text-center">Leave Type</th>
                <th class="text-center">Dates</th>
                <th class="text-center">Duration</th>
                <th class="text-center">Details</th>
                <th class="text-center">Status</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in modifiedLeaves" :key="index">
                <td class="text-center">
                  <img width="20px" class="rounded-circle mr-10" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=50`">
                  <span>{{row.firstName}} {{row.lastName}}</span>
                </td>
                <td class="text-center text-capitalize">
                  <span class="badge badge-pill" :class="getDepartment(row) !== 'Development' ? (getDepartment(row) === 'Support' ? 'badge-success' : 'badge-danger') : 'badge-info'">{{getDepartment(row)}}</span>
                </td>
                <td class="text-center">{{leaveTypes[row.leaveType]}}</td>
                <td width="15%" class="text-center">
                  <span v-if="row.leaveType !== 'partialLeave' && !(row.leaveType === 'workEvent' && row.partialLeave)">
                    {{row.leaveDays && row.leaveDays.length > 1 ? `${parseDate(row.start)} &nbsp - &nbsp ${parseDate(row.end)}` : parseDate(row.start)}}
                  </span>
                  <span v-else>{{parseDate(row.partialLeave.date)}} <span class="text-danger fw-600">({{row.partialLeave.from}} - {{row.partialLeave.to}})</span></span>
                </td>
                <td class="text-center">
                  <span v-if="row.leaveType === 'workEvent'">Not eligible to count</span>
                  <span v-else-if="row.leaveType !== 'partialLeave'">
                    {{row.leaveDays && row.leaveDays.length > 0 ? row.leaveDays.length : '-'}}
                  </span>
                  <span v-else-if="row.leaveType === 'partialLeave'">
                {{getDuration(row)}} (hrs)
              </span>
                </td>
                <td width="20%" class="text-center">
                  <span class="make-cursor-pointer" :style="!row.details ? 'opacity: 0.5;' : ''" @mouseover="getTitle(row, true, index)" :id="`${selectedTab}_${index}`" @mouseleave="getTitle(row, false, index)">{{row.details && row.details.length > 500 ? row.details.substring(0,500) + '...' : row.details || 'N/A'}}</span>
                </td>
                <td class="text-center">
                  <span :title="row.status === 'approved' ? row.actionBy : ''" data-toggle="tooltip" data-placement="top" class="badge badge-pill make-cursor-pointer" :class="getStatusClass(row.status)">{{row.status}}</span>
                </td>
                <td class="text-center">
                  <div class="dropdown">
                    <template v-if="index !== selectedIndex">
                      <i class="fa fa-ellipsis-v dropdown-toggle make-cursor-pointer fs-16 pr-20 pl-20" aria-hidden="true" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a @click="actionOnLeave({...row, index}, 'approved')" :class="{'disabled': row.status !== 'pending' || row.status === 'approved'}" class="dropdown-item" href="#">Approve</a>
                        <a @click="actionOnLeave({...row, index}, 'rejected')" :class="{'disabled': row.status !== 'pending' || row.status === 'approved'}"  class="dropdown-item" href="#">Reject</a>
                        <a @click="deleteLeave({...row, index})" class="dropdown-item" href="#">Delete</a>
                      </div>
                    </template>
                    <i v-else class="fa fa-spin fa-spinner"></i>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <add-leave-modal ref="addLeaveModal"/>
  </div>
</template>
<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";
import md5 from "crypto-js/md5";
import AddLeaveModal from "@/components/Admin/AdminDashboard/modal/applyStaffLeaveModal.vue";
import LeaveRecords from "@/components/Admin/AdminDashboard/leaveRecords.vue";
import moment from "moment";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'LeaveManagement',
  components: {LeaveRecords, AddLeaveModal, DateRangePicker},
  data() {
    return {
      department: {
        'support': 'Support',
        'sales': 'Client Success',
        'development': 'Development',
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      status: '',
      allAdmins: [],
      selectedTab: 'allLeaves',
      leaves: [],
      loading: false,
      isHR: false,
      listener: null,
      selectedIndex: -1,
      leaveTypes: {
        'sick': 'Sick',
        'pto': 'PTO',
        'vacation': 'Vacation',
        'partialLeave': 'Partial Leave',
        'workEvent': 'Work Event',
      }
    }
  },
  beforeDestroy() {
    if(this.listener){
      this.listener()
    }
  },
  mounted() {
    console.log('query params', this.$route.query.type)
    this.getHrRole()
    this.getAllLeaves()
    this.getAllAdmins()
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  },
  computed: {
    modifiedLeaves() {
      let array = this.leaves;
      if(this.status) {
        array = array.filter(el => el.status === this.status)
      }
      if(this.dateRange.startDate && this.dateRange.endDate) {
        const start = moment(this.dateRange.startDate).format('YYYY-MM-DD');
        const end = moment(this.dateRange.endDate).format('YYYY-MM-DD');
        array = array.filter(el => {
          if(el.leaveDays) {
            const obj = el.leaveDays.find(leave => leave >= start && leave <= end);
            return !!obj
          }
          return false
        })
      }
      return array.sort((a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      })
    },
    getPendingLeaves() {
      const array = this.leaves.filter(leave => leave.status === 'pending')
      return array.length
    },
    showAllLeaves() {
      return this.type === 'allLeaves' && this.isHR
    },
    type() {
      return this.$route.query.type
    },
    upcomingLeaves() {
      const array = [];
      const date = moment(new Date()).format('YYYY-MM-DD');
      this.leaves.map(el => {
        if(el.leaveDays && el.status === 'approved') {
          const obj = el.leaveDays.find(el2 => new Date(el2) >= new Date(date) && el.email !== this.user.email);
          console.log(obj)
          if(obj) {
            array.push(el)
          }
        }
      })
      console.log('upcomingLeaves', array);
      array.sort((a, b) => {
        const aMin = a.leaveDays && a.leaveDays.length ? Math.min(...a.leaveDays.map(d => new Date(d).getTime())) : Infinity;
        const bMin = b.leaveDays && b.leaveDays.length ? Math.min(...b.leaveDays.map(d => new Date(d).getTime())) : Infinity;
        return bMin - aMin;
      });
      return array
    },
    myLeaves() {
      return this.leaves.filter(el => el.email === this.user.email)
    },
    user(){
      return this.$store.getters.user;
    }
  },
  watch: {
    modifiedLeaves(val) {
      this.renderDatatable()
    },
    dateRange(val) {
      console.log('date range', moment(val.startDate).format('YYYY-MM-DD'));
      const start = moment(val.startDate).format('YYYY-MM-DD');
      const end = moment(val.endDate).format('YYYY-MM-DD');

    }
  },
  methods: {
    getDepartment(row) {
      const obj = this.allAdmins.find(el => el.email === row.email)
      return obj ? this.department[obj.department] || 'Unknown' : 'Unknown'
    },
    resetFilters() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      }
      this.status = ''
    },
    formattedDateWithOutTime(timestamp){
      return moment(timestamp).format("MMM D, YYYY");
    },
    async getAllAdmins() {
      const ref = await db.collection('users').where('userType', 'in', ['admin', 'manager', 'super-admin']).get();
      if(ref.size) {
        ref.forEach((doc) => {
          const data = doc.data();
          if(!data.email.includes('septemsystems')){
            this.allAdmins.push({uid: doc.id, ...data})
          }
        })
      }
    },
    getTitle(row, flag, index) {
      if(!flag || !row.details) {
        return true
      }
      tippy(`#${this.selectedTab}_${index}`, {
        content: row.details,
        allowHTML: true,
        theme: 'dark', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    getDuration(row) {
      let partialTime  = 0
      const fromTime = new Date(`${row.partialLeave.date}T${row.partialLeave.from}:00`);
      const toTime = new Date(`${row.partialLeave.date}T${row.partialLeave.to}:00`);
      const diffInMs = toTime - fromTime;
      const totalMinutes = Math.abs(diffInMs / (1000 * 60));
      partialTime = partialTime + totalMinutes
      return Number(partialTime/60)
    },
    parseDate(date) {
      return moment(date).format('DD MMM, YYYY')
    },
    openLeaveModal() {
      this.$refs.addLeaveModal.load(this.leaves, this.allAdmins)
    },
    renderDatatable(id) {
      if($.fn.DataTable.isDataTable('#allLeavesTable')) {
        $(`#allLeavesTable`).DataTable().destroy();
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      setTimeout(function () {
        $(`#allLeavesTable`).dataTable({
          pagingType: "full_numbers",
          ordering: false,
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo" : false,
        });
      }, 0)
    },

    exportCSV() {
      const escape = val => {
        if (val === null || val === undefined) return '';
        const str = String(val).replace(/"/g, '""');
        return str.includes(',') || str.includes('"') || str.includes('\n') ? `"${str}"` : str;
      };

      const headers = ['Employee Name', 'Email', 'Department', 'Leave Type', 'Dates', 'Duration', 'Details', 'Status', 'Action By', 'Created At'];

      const rows = this.modifiedLeaves.map(row => {
        const name = `${row.firstName || ''} ${row.lastName || ''}`.trim();
        const dept = this.getDepartment(row);
        const leaveType = this.leaveTypes[row.leaveType] || row.leaveType || '';
        let dates = '';
        if (row.leaveType === 'partialLeave' || (row.leaveType === 'workEvent' && row.partialLeave)) {
          dates = row.partialLeave ? `${this.parseDate(row.partialLeave.date)} (${row.partialLeave.from} - ${row.partialLeave.to})` : '';
        } else {
          dates = row.leaveDays && row.leaveDays.length > 1
            ? `${this.parseDate(row.start)} - ${this.parseDate(row.end)}`
            : this.parseDate(row.start);
        }
        let duration = '';
        if (row.leaveType === 'workEvent') duration = 'Not eligible to count';
        else if (row.leaveType === 'partialLeave') duration = `${this.getDuration(row)} hrs`;
        else duration = row.leaveDays && row.leaveDays.length > 0 ? `${row.leaveDays.length} day(s)` : '-';

        return [
          escape(name),
          escape(row.email),
          escape(dept),
          escape(leaveType),
          escape(dates),
          escape(duration),
          escape(row.details),
          escape(row.status),
          escape(row.actionBy),
          escape(row.createdAt ? new Date(row.createdAt).toLocaleDateString() : ''),
        ].join(',');
      });

      const csv = [headers.join(','), ...rows].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `leave-requests-${new Date().toISOString().slice(0, 10)}.csv`;
      link.click();
      URL.revokeObjectURL(url);
    },

    getStatusClass(status) {
      let statusClass = '';
      if(status === 'pending') {
        statusClass = 'badge-warning';
      } else if(status === 'approved') {
        statusClass = 'badge-success';
      } else if(status === 'rejected') {
        statusClass = 'badge-danger';
      }else if(status === 'withdrawn') {
        statusClass = 'badge-default';
      }
      return statusClass;
    },
    emailHashGravatar(email) {
      console.log('email,', email)
      if (!email) {
        return null
      } else {
        return md5(email.toLowerCase()).toString()
      }
    },
    async actionOnLeave(row, status) {
      try {
        if(row.status !== 'pending') {
          return true
        }
        this.selectedIndex = row.index;
        const ref = await db.collection('leaveRecords').doc(row.id).update({ status, actionBy: `${this.user.firstName} ${this.user.lastName}` });
        // this.$parent.getAllLeaves()
        swal('Success', `You have successfully ${status} leave.`, 'success');
      } catch (e) {
        swal('Error', `Something went wrong while updating leave status.`, 'error');
      } finally {
        this.selectedIndex = -1;
      }
    },
    async deleteLeave(row) {
      try {
        swal({
          title: "Are you sure?",
          text: "Are you sure that you want to delete leave?",
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then(async (result) => {
          if (result.value) {
            this.selectedIndex = row.index;
            await db.collection('leaveRecords').doc(row.id).delete();
            swal('Success', `You have successfully deleted the leave.`, 'success');
            this.selectedIndex = -1;
          }
        })
      } catch (e) {
        swal('Error', `Something went wrong while deleting leave status.`, 'error');
      } finally {
        this.selectedIndex = -1;
      }
    },
    async getAllLeaves() {
      this.loading = true;
      this.leaves = []
      this.listener = await db.collection('leaveRecords').onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          if (changeDoc.type === 'added'){
            console.log('addin new', 418)
            this.leaves.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if(changeDoc.type === 'modified') {
            console.log('modified')
            this.leaves = this.leaves.filter(el => el.id !== changeDoc.doc.id)
            this.leaves.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if(changeDoc.type === 'removed') {
            this.leaves = this.leaves.filter(el => el.id !== changeDoc.doc.id)
          }
        });
      });
      this.loading = false;
    },
    async getHrRole() {
      const ref = await db.collection('users').doc(this.user.uid).get();
      if(ref.exists) {
        const {isHR} = ref.data()
        this.isHR = isHR;
        if(!this.isHR) {
          this.$router.push('/')
        }
      }
      this.loading = false;
    }
  }
}

</script>
<style scoped>

.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border: 0;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  border: 1px solid transparent !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff !important;
}

.nav-tabs .nav-item .nav-link.active {
  color: #5b7cfb;
}
.table-light{
  background: #fafafa !important;
}

thead{
  tr {
    th{
      text-transform: capitalize !important;
    }
  }
}
.badge-warning {
  background: #fcf3dc;
  color: #ecb62d;
}
.badge-info {
  background: #50dbff3d;
  color: #3c98b7;
}.badge-default {
  background: #d3d3d32b;
  color: darkgray;
}.badge-success {
   background: #ebfdf3;
   color: #047a48;
 }.badge-danger {
    background: #fff0ea;
    color: #ef8156;
  }
.fa-ellipsis-v:after{
  display: none;
}
.dropdown-item.disabled, .dropdown-item:disabled{
  color: #6c757d;
}
.badge-default {
  background: #f0f0f0 ;
  color: #66615b;
}
:deep(.reportrange-text){
  padding: 9px 10px !important;
}
</style>
